/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import {
  getLogger,
  install as installFrontend,
  setExtraContext,
  setUserContext,
} from "@novivia/logger/frontend";
import {request} from "ajax";

export {
  captureException,
  setExtraContext,
  showReportDialog,
} from "@novivia/logger/frontend";

const shouldLog = !__DEV__;

export function install() {
  if (!shouldLog) {
    return console.info(
      "Not installing logging since environment is not production-like.",
    );
  }

  installFrontend({
    makeRequest: options => {
      request({
        data: options.data,
        query: options.auth,
        type: "POST",
        url: options.url,
      })
      .then(options.onSuccess)
      .catch(options.onError);
    },
  });

  if (AuctionEx.tenantId) {
    setExtraContext({
      tenant: AuctionEx.tenantId,
    });
  }

  if (AuctionEx.user) {
    const {
      user: {
        email,
        id,
        name,
      },
    } = AuctionEx;

    // If the user is logged in, attach useful information to logs and errors.
    setUserContext({
      email,
      id,
      name,
    });
  }
}

export const logger = getLogger({shouldLog});



// WEBPACK FOOTER //
// ../logging.js